import React from 'react';
import type { ListingSummary } from '../../../types/ListingTypes';
import styles from '../../../styles/ListingManagement.module.css';

interface ListingProps {
    listings: ListingSummary[];
}

const ListStats: React.FC<ListingProps> = ({ listings }) => {
    const openCount = listings.filter((l) => l.status === 'Open').length;
    const pendingCount = listings.filter((l) => l.status === 'Pending').length;
    const incompleteCount = listings.filter((l) => l.status === 'Incomplete').length;

    return (
        <div className={styles.listingManagementSection}>
            <div className={styles.listingStatCards}>
            {[
              { label: 'Total',      value: listings.length, color: '#2563eb' },
              { label: 'Open',       value: openCount,       color: '#10b981' },
              { label: 'Pending',    value: pendingCount,    color: '#d97706' },
              { label: 'Incomplete', value: incompleteCount, color: '#ef4444' },
            ].map(s => (
              <div key={s.label} className={styles.listingStatCard}>
                <span className={styles.listingStatValue} style={{ color: s.color }}>{s.value}</span>
                <span className={styles.listingStatLabel}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
    );
}

export default ListStats;